module.exports = __webpack_public_path__ + "static/blog-logo-65e783f1d764462756a8a97990e6a4c7.svg";